import { useState, useCallback } from 'react';

/**
 * useContactsMigration
 *
 * NOTE: Firebase to PostgreSQL migration has already been completed.
 * This hook is now a no-op stub. The Firestore dependency has been removed.
 * If a future migration is needed, implement via Express API.
 */
export function useProfilesMigration() {
    const [migrating] = useState(false);
    const [progress] = useState({
        current: 0,
        total: 0,
        success: 0,
        skipped: 0,
        skippedDuplicate: 0,
        skippedInvalid: 0,
        failed: 0
    });
    const [error] = useState(null);

    const migrateProfiles = useCallback(async () => {
        console.warn('[useProfilesMigration] Migration already completed. This hook is a no-op stub.');
        return { success: 0, skipped: 0, failed: 0, total: 0 };
    }, []);

    return {
        migrateProfiles,
        migrating,
        progress,
        error
    };
}
